import { SsMount } from 'src/js/dom/mount.js';
import { SsLazy } from 'src/js/dom/lazy.js';
import { velocity } from 'src/js/lib/velocity.js';
import { throttle } from 'lodash';
import { gallery } from 'src/js/dom/sub-page.js';
import $ from 'jquery';

export class SsLooks {
  constructor ( id ) {
    this.id = id;
    this.dom = new SsMount( document.createElement( 'div' ) );
    this.imgs = [];
    this.$figs = [];
    this.clickID = throttle( this.clickLsn, 100 );
  }

  clickLsn ( evt ) {
    const self = evt.data;
    self.offClicks();
    const index = evt.currentTarget.getAttribute( 'data-index' );
    gallery.open( Number( index ) );
  }

  onClicks () {
    this.$figs.forEach( $fig => {
      $fig.addClass( 'clickable' );
      $fig.on( 'click', null, this, this.clickID );
    });
  }

  offClicks () {
    this.$figs.forEach( $fig => {
      $fig.removeClass( 'clickable' );
      $fig.off( 'click', this.clickID );
    });
  }

  makeDom ( path, num ) {
    for ( let i = 0; i < num; i += 1 ) {
      const fig = document.createElement( 'figure' );
      const wrap = document.createElement( 'div' );
      const img = new Image();

      fig.setAttribute( 'class', [
        'looks-item',
      ].join( ' ' ));

      fig.setAttribute( 'data-index', i );

      wrap.setAttribute( 'class', [
        'looks-img-wrap',
      ].join( ' ' ));

      img.setAttribute( 'class', [
        'ghost',
        'looks-img'
      ].join( ' ' ));

      img.setAttribute(
        'data-src',
        `${ path }l_${ i }.jpg`
      );

      wrap.append( img );

      fig.appendChild( wrap );

      this.imgs.push( new SsLazy( img ) );
      this.$figs.push( $( fig ) );

      this.dom.$.append( fig );
    }

    this.dom.$.addClass( 'looks-flex' );

    return this.dom.elm;
  }

  getDom () {
    return this.dom.elm;
  }

  async lazyLoad () {
    this.imgs.forEach( async ( img, i ) => {
      await img.lazy();
      velocity( img.elm, {
        props: {
          opacity: [ 1, 0 ]
        },
        opts: {
          delay: i * 80,
          duration: 350,
          easing: 'easeInOutCubic',
        },
      });
    });
  }
}
